import { VideoItem } from 'services/data-manager/types.ts';

function getGuardTimeSchedule(videoItem: VideoItem) {
    const { guardTime, guardTimeEnd, originalProgram } = videoItem;
    let { startTime, endTime, duration } = videoItem;

    const shouldAdjustStartTime = guardTime && !!originalProgram;
    const shouldAdjustEndTime = guardTimeEnd && !!originalProgram;

    if (shouldAdjustStartTime) {
        if (startTime != null) {
            startTime -= guardTime;
        }

        if (duration != null) {
            duration += guardTime;
        }
    }

    if (shouldAdjustEndTime) {
        if (endTime != null) {
            endTime += guardTimeEnd;
        }

        if (duration != null) {
            duration += guardTimeEnd;
        }
    }

    return {
        duration,
        startTime,
        endTime,
    };
}

export default getGuardTimeSchedule;
